import { Button, Header, LoadingSpinner, TextInput } from '@components/Generic'
import axios from 'axios'
import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { StoreContext } from '@store/Root.store'
import { API_URL } from '@/constants/apiUrl'
import { cx } from '@/utils/cx'
import { isAccountInformation } from '@/methods/tinkTransactionType'

export const AccountHolderMockPage = observer(() => {
  const store = useContext(StoreContext)

  const { isMobile } = store.AppState
  const { context } = store.ScenarioState
  const { currentScenarioId } = store.ScenarioState

  const { userDataPage: trans } = store.TranslationsState.translations

  // AIS sessions have no sender to mock: the backend never sets the flag for
  // them, and this guard keeps the step hidden even if it ever did.
  const shouldMockSenderHolder =
    !isAccountInformation(context) && Boolean(context?.shouldMockSenderHolder)

  const [accountHolderValue, setAccountHolderValue] = useState('')
  const [validationErrorHolder, setValidationErrorHolder] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)

  const handleProceed = async (e: { preventDefault: () => void }) => {
    e.preventDefault()
    if (currentScenarioId !== 'localTests') {
      setBtnLoading(true)

      const output: {
        senderHolder?: string
      } = {
        senderHolder: accountHolderValue,
      }

      await axios.post(`${API_URL}/micropayment/update-sender-holder-mock`, output, {
        withCredentials: true,
      })

      setBtnLoading(false)
    }

    store.ScenarioState.nextPage()
  }

  function getDisabledState() {
    let output = true

    if (shouldMockSenderHolder) {
      if (accountHolderValue.length && !validationErrorHolder) {
        output = false
      }
    }

    return output
  }

  useEffect(() => {
    if (!shouldMockSenderHolder) {
      store.ScenarioState.skipStep()
    }
  }, [])

  return (
    <div className="page-container">
      <form onSubmit={(e) => handleProceed(e)}>
        <Header>{trans.header}</Header>
        <div>
          {shouldMockSenderHolder ? (
            <div className="generic__input-container">
              <div className="generic__label">{trans.inputLabel}</div>
              <TextInput
                type="text"
                value={accountHolderValue}
                {...(trans.emailErrorLabel ? { emailErrorLabel: trans.emailErrorLabel } : {})}
                {...(trans.phoneErrorLabel ? { phoneErrorLabel: trans.phoneErrorLabel } : {})}
                {...(trans.requiredErrorLabel
                  ? { requiredErrorLabel: trans.requiredErrorLabel }
                  : {})}
                onChange={(value) => {
                  setAccountHolderValue(value)
                }}
                onError={(e) => setValidationErrorHolder(e)}
                id="holder-input"
                autoComplete="name"
              />
            </div>
          ) : (
            <></>
          )}
        </div>
        <div className="layout__content-container-bottom-fixed">
          {!isMobile ? <div className="layout__content-container-bottom-left" /> : <></>}
          <Button
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => handleProceed(e)}
            disabled={getDisabledState()}
            id="page-submit"
            type="submit"
          >
            {btnLoading && <LoadingSpinner inButton />}
            <span
              className={cx('generic__button-text', btnLoading && 'generic__button-text--loading')}
            >
              {trans.proceed}
            </span>
          </Button>
        </div>
      </form>
    </div>
  )
})
